import { buildUrl, VIDEO_API_URL } from "../config/urls";
import useSWR from "swr";
import * as Cookie from "js-cookie";

export const useVideoRecord = (url: string) => {
  return useSWR(url);
};

export const useVideoData = (applicationId: string) => {
  const userDefinedLocale = Cookie.get("hvh-locale");
  const DEFAULT_LOCALE = "en-US";
  const locale =
    userDefinedLocale && userDefinedLocale.length > 0
      ? userDefinedLocale
      : DEFAULT_LOCALE;
  return useSWR(buildUrl(VIDEO_API_URL, { applicationId, locale }));
};
